import type { RootState } from '@core/Store'
import { IStructuredSearchResults, SelectedTrackType, StructuredSearchFields } from '.'

export const selectStructuredSearch = (state: RootState) => state.structuredSearch

export const selectSearchCriteria = (state: RootState): StructuredSearchFields =>
  state.structuredSearch.searchCriteria

export const selectSelectedTracks = (state: RootState): SelectedTrackType =>
  state.structuredSearch.searchCriteria.selectedTracks

export const selectSearchResults = (state: RootState): IStructuredSearchResults =>
  state.structuredSearch.searchResults
